"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var addComma = function addComma(input) {
  if (!input) return;
  var number = parseInt(input);
  if (!number) return;
  return number.toLocaleString('en-US');
};

var _default = addComma;
exports.default = _default;